'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var baseX = require('./baseX.cjs');

/**
 * A string serializer that uses base10 encoding.
 * @category Serializers
 */
const base10 = baseX.baseX('0123456789');

exports.base10 = base10;
//# sourceMappingURL=base10.cjs.map
